import { mc } from '@lss/common/game/characters/MC';
import { Phone } from '../../src/components/phoneUI/PhoneClass';
import Game from '../../src/shell/Game';
import ImageClass from "../../src/shell/Image";
import Question from '../../src/shell/Questions';
import { jump } from '../../src/shell/jump';
import { ann } from '../characters/Ann';
import { chris } from '../characters/Chris';
import { empty } from "../characters/empty";
import { rick } from '../characters/Rick';
import { vanessa } from '../characters/Vanessa';
import { annImages } from '../helpers/annInstaImages';
import { doDoorKnock, doImageShake, doSmsSound, doTransition } from '../helpers/helpers';
import { extras, images } from "./images";
import { ClubHome } from './V4';
import { ClubEventJoeInsideAnnAloneStatus0, ClubEventJoeInsideAnnAloneStatus01InstaTalk, ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar } from './V4_BarWithJoey';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';


export const ClubEventWithoutJoe = async (): Promise<any> => {
    ImageClass.setImage(images.v4.VanessaDoor, { transition: true });
    doDoorKnock();
    mc.think(`Someone is knocking at the front door.`);
    mc.think(`I am not expecting anyone...`);
    ImageClass.setImage(images.v4.VanessaAngryDoor);
    vanessa.talk(`${mc.name}, are you a fucking moron???`);
    vanessa.talk(`I can't believe you told him!`);
    vanessa.talk(`Do you need a guide on how to blackmail people???`);
    if (Question.globalAnswers.v2VanessaDressLikedTheMost === "white") {

        mc.talk(`Why aren't you wearing the white dress I picked for you??`);
        vanessa.talk(`Oh my God, shut up!`);
    } else if (Question.globalAnswers.v2VanessaDressLikedTheMost === "black") {

        mc.talk(`Why aren't you wearing the black dress I picked for you??`);
        vanessa.talk(`Oh my God, shut up!`);
    } else {
        mc.talk(`Nice, I see that you picked my dress.`);
        if (Question.globalAnswers.v2VanessaClothesRedBlackDress === "removePanties") {

            mc.talk(`But I told you it's better without the panties.`);
            vanessa.talk(`Shut up!\nI wanted to wear it anyway!`);
        }

    }
    doSmsSound();
    return jump(ClubEventWithoutJoe_Question, "ClubEventWithoutJoe_Question");

};

export const ClubEventWithoutJoe_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v4.VanessaAngryDoor);
    await mc.setQuestion(new Question({ text: `I got a text.`, options: { think: true }, key: `v4VanessaAngryCheckedTextNow` })
        .option({ title: `Check it now`, key: true })
        .option({ title: `Wait for Vanessa to leave`, key: false }));


    if (Question.globalAnswers.v4VanessaAngryCheckedTextNow) {

        return jump(ClubEventWithoutJoe_Question_Check, "ClubEventWithoutJoe_Question_Check");
    } else {
        return jump(ClubEventWithoutJoe_Question_Ignore, "ClubEventWithoutJoe_Question_Ignore");

    }

};

export const ClubEventWithoutJoe_Question_Check = async (): Promise<any> => {
    ImageClass.setImage(images.v4.VanessaAngryDoor);

    await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann2 }, async () => {
        Phone.setMessage({ character: ann.character, text: `${mc.name}?`, options: { wait: false } });
        Phone.setMessage({ character: ann.character, text: `Please text me back when you see it.`, options: { wait: true } });

        Phone.closeMessagesUI();
    });

    mc.talk(`I wonder what she wants...`);
    vanessa.talk(`Are you seriously checking your phone while I'm yelling at you?`);


    return jump(ClubEventWithoutJoeAnnSMS, "ClubEventWithoutJoeAnnSMS");
};


export const ClubEventWithoutJoe_Question_Ignore = async (): Promise<any> => {
    ImageClass.setImage(images.v4.VanessaAngryDoor);
    vanessa.talk(`You ruined everything!`);
    return jump(ClubEventWithoutJoeAnnSMS, "ClubEventWithoutJoeAnnSMS");
};

export const ClubEventWithoutJoeAnnSMS = async (): Promise<any> => {
    if (!Game.seenScenarios.includes(`ClubEventWithoutJoeAnnSMS`)) {
        ImageClass.setImage(images.v4.VanessaAngryDoor);
        vanessa.talk(`I hope you enjoyed my mini-blowjob because it was your last!`);
        doImageShake(images.v4.Door);
        empty.think(`*SLAM*`);


        ImageClass.setImage(images.v1.RoomComputerAlone);
        mc.think(`Wow... She was pissed.`);
        mc.think(`She must have spoken with Joe after I left.`);
        if (Question.globalAnswers.v4VanessaAngryCheckedTextNow) {

            mc.think(`Ann sent me a message, let's see what she wanted.`);
        } else {

            mc.think(`Now I can see who sent me that text.`);
        }

        await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann2 }, async () => {

            Phone.setMessage({ character: ann.character, text: `${mc.name}?`, options: { wait: false } });
            Phone.setMessage({ character: ann.character, text: `Please text me back when you see it.`, options: { wait: false } });

            Phone.setMessage({ character: mc.character, text: `What happened?`, options: { wait: false } });
            Phone.setMessage({ character: ann.character, text: `I have no idea, Vanessa just called me.\nShe was screaming something about a moron.` });
            Phone.setMessage({ character: ann.character, text: `She said that the four of us were supposed to meet at the bar to celebrate Joe's birthday but it's not going to happen now.` });
            Phone.setMessage({ character: ann.character, text: `Do you know what happened?` });
            Phone.setMessage({ character: mc.character, text: `I have an idea...` });
            Phone.setMessage({ character: ann.character, text: `?` });
            Phone.setMessage({ character: mc.character, text: `It's better if I tell you this in person.` });
            Phone.setMessage({ character: ann.character, text: `Alright, listen, Vanessa should come over and both of us will be going to the bar together.` });
            Phone.setMessage({ character: ann.character, text: `Give me thirty minutes to calm her down and then join us.` });
            Phone.setMessage({ character: ann.character, text: `Is that ok?` });
            Phone.setMessage({ character: mc.character, text: `Sure.` });
            Phone.setMessage({ character: mc.character, text: `But she won't be happy to see me.` });
            Phone.setMessage({ character: ann.character, text: `Were you the one who made her upset?` });
            Phone.setMessage({ character: mc.character, text: `I'll explain everything once I get there.` });
            Phone.setMessage({ character: ann.character, text: `Ok.` });
            Phone.setMessage({ character: ann.character, text: `Thanks. It's hard to contain her alone in a place like that...` });
            Phone.closeMessagesUI();
        });


    }
    return jump(ClubEventWithoutJoeAnnOutside1, "ClubEventWithoutJoeAnnOutside1");
};

export const ClubEventWithoutJoeAnnOutside1 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 2, wait: 2 });
    ImageClass.setImage(images.v1.RoomComputerAlone);
    mc.think(`It's been thirty minutes, it's time to meet Ann.`);

    doTransition(images.v4.BarOutsideAnnNoJoe1);
    ann.talk(`Hey.`);
    await ann.setQuestion(new Question({ text: `I'm so glad you got here quickly.`, options: { think: false }, key: `v4ComplimentedAnnOnDress` })
        .option({ title: `Compliment her on the dress`, key: true })
        .option({ title: `Don't compliment her`, key: false }));


    if (Question.globalAnswers.v4ComplimentedAnnOnDress) {
        await mc.set((properties) => {
            properties.annRelationship++;
        });
        mc.talk(`You look good in that dress.`);
        ImageClass.setImage(images.v4.BarOutsideAnnNoJoe1_2);
        ann.talk(`Oh, thank you. Hehe.`);
        ann.talk(`I hope it's not too much.`);
        ann.talk(`It was supposed to be a birthday party...`);
        mc.talk(`It's not, it looks good.`);
        ann.talk(`So, Vanessa is inside... Drinking.`);
        mc.talk(`Did she tell you what happened?`);
    } else {

        mc.talk(`Did she tell you what happened?`);
    }
    ann.talk(`No, she didn't.`);
    ImageClass.setImage(images.v4.BarOutsideAnnNoJoe2);
    ann.talk(`She hasn't stoped drinking since we arrived.`);
    ImageClass.setImage(images.v4.BarOutsideAnnNoJoe3);
    ann.talk(`We should go inside, I don't want to leave her by herself any longer.`);
    mc.talk(`Let's go.`);
    return jump(ClubEventWithoutJoeInside, "ClubEventWithoutJoeInside");
};


export const ClubEventWithoutJoeInside = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarInsideNoJoe1);
    vanessa.talk(`Oh! Look who it is.`);
    vanessa.talk(`Mr. Doofus!`);
    mc.think(`At least she stopped screaming.`);
    vanessa.talk(`What are you doing here?`);
    ann.talk(`I invited him.`);
    vanessa.talk(`Why? Did he blackmail you also?`);
    ImageClass.setImage(images.v4.BarInsideNoJoe2);
    ann.talk(`Blackmail?`);
    ImageClass.setImage(images.v4.BarInsideNoJoeVanessaDrinking);
    ann.talk(`What?`);
    ImageClass.setImage(images.v4.BarInsideNoJoe3);
    vanessa.talk(`Yes, I gave ${mc.name} a blowjob.`);
    ann.talk(`You did what??`);
    ann.talk(`Why???`);
    vanessa.talk(`Because I gave one to Chris.`);
    ann.talk(`Chris??? Who is Chris?`);
    ann.talk(`Wait, the bartender's name is Chris.`);
    vanessa.talk(`That's the one.`);
    vanessa.talk(`Where is he anyway, I'm bored.`);
    ImageClass.setImage(images.v4.BarInsideNoJoeCallingChris);
    vanessa.talk(`Chris!!`, { method: "Shouting" });
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering1);
    ann.talk(`${mc.name}? Can you explain what's going on here? Vanessa can't complete a full sentence.`);
    mc.talk(`Fine.`);
    mc.talk(`Remember that day that I met with Vanessa instead of you?`);
    ann.talk(`Yeah.`);
    mc.talk(`So, on that same day, Vanessa stayed here with Chris and she sucked him off...`);
    mc.talk(`The next day I came here and saw a picture of her with him on his phone...`);
    ann.talk(`Wow, how did you see it?`);
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering2);
    mc.talk(`I asked him what they were doing, and he just decided to show me.`);
    mc.talk(`I think they are gossiping about me.`);
    ann.talk(`Well, we are also talking about them...`);
    mc.talk(`Yeah, but we are just talking, they look like they are planning something.`);
    ann.talk(`Forget about them, just continue.`);
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering1);

    await mc.setQuestion(new Question({ text: `Alright.\nEarlier today, I went to visit her at her work to confront her about that.`, options: { think: false }, key: `v4WithoutJoeyLiedToAnn` })
        .option({ title: `Lie`, key: true })
        .option({ title: `Tell the truth`, key: false }));


    if (Question.globalAnswers.v4WithoutJoeyLiedToAnn) {

        await mc.set((properties) => {
            properties.toldAnnBlackMail = false;
            properties.liar++;
        });

        return jump(ClubEventWithoutJoeInsideLie, "ClubEventWithoutJoeInsideLie");
    } else {
        await mc.set((properties) => {
            properties.toldAnnBlackMail = true;
            properties.liar--;
        });
        return jump(ClubEventWithoutJoeInsideTruth, "ClubEventWithoutJoeInsideTruth");
    }
};

export const ClubEventWithoutJoeInsideLie = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering1);
    mc.talk(`She started flirting and touching me as soon as I mentioned it.`);
    mc.talk(`I didn't resist as first and she got on her knees and started blowing me.`);
    mc.talk(`But I put a stop to it.`);
    ann.talk(`Good thing that you did.`);
    ann.talk(`But why did she say you blackmailed her?`);
    mc.talk(`I don't know, she is kinda drunk.`);
    ann.talk(`Yeah... She doesn't make sense when she drinks.`);
    ann.talk(`Wait, but that doesn't explain why she is upset.`);
    mc.talk(`Because there is more.`);
    ann.talk(`Oh, sorry, continue.`);
    return jump(ClubEventWithoutJoeInsideVanessaDancing, "ClubEventWithoutJoeInsideVanessaDancing");
};
export const ClubEventWithoutJoeInsideTruth = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering1);
    mc.talk(`I told her I know everything and I wanted a blowjob to keep my mouth shut.`);
    ann.talk(`Are you serious?`);
    ann.talk(`I don't know what's more gross... What Vanessa did, or you?`);
    mc.talk(`Let me finish.`);
    return jump(ClubEventWithoutJoeInsideVanessaDancing, "ClubEventWithoutJoeInsideVanessaDancing");
};
export const ClubEventWithoutJoeInsideVanessaDancing = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering1);
    mc.talk(`So today I met with Joe, and I told him about what happened.`);
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering2);
    mc.talk(`He was furious...`);
    ann.talk(`Understandable...`);
    ImageClass.setImage(images.v4.BarInsideNoJoeWhispering1);
    if (Question.globalAnswers.v4WithoutJoeyLiedToAnn) {
        ann.talk(`Why did you do it?`);
        mc.talk(`Tell Joey?`);
        ann.talk(`That too.`);
        mc.talk(`I don't know.`);
        mc.talk(`He is my best friend and that was my way of showing him who Vanessa really is.`);
        ann.talk(`Do you really believe he hadn't figured that out already?`);
        mc.talk(`You weren't there when I talked to him.`);
        mc.talk(`He was blind.`);
    } else {

        ann.talk(`But you told Vanessa to stop.`);
        mc.talk(`I know, but he didn't accept that fact.`);
    }
    ann.talk(`So right now he is alone at his home on his birthday?`);
    mc.talk(`I guess.`);
    ImageClass.setImage(images.v4.BarInsideNoJoe2DrinksFull);
    vanessa.talk(`Ann, it's time for a drink!`);
    ann.talk(`What? No...`);

    vanessa.talk(`You said you will do anything to cheer me up.`);
    ann.talk(`I did...`);
    vanessa.talk(`Drinking with my best friend is what makes me feel better.`);
    vanessa.talk(`When we got here you said that you don't want to drink so you could watch my back.`);
    vanessa.talk(`Now doofus is here so he can do it.`);
    vanessa.talk(`You ran out of excuses.`);
    ann.talk(`Fine...`);
    vanessa.talk(`Cheers!`);
    ImageClass.setImage(images.v4.BarInsideNoJoeDrinking, { duration: 0.8 });
    await ann.set((properties) => {
        properties.v4JoeyBirthdayDrinksNum++;
    });
    mc.think(`So Ann does drink when you put enough pressure on her.`);
    ImageClass.setImage(images.v4.BarInsideNoJoe2DrinksEmpty);
    ann.talk(`Yuk...`);
    vanessa.talk(`You are the best friend ever!`);
    vanessa.talk(`Ann! Come, I wanna dance.`);
    ann.talk(`I am not drunk enough for that...`);
    vanessa.talk(`So let's drink another!`);
    ann.talk(`No, it's too soon.`);
    vanessa.talk(`Fine. But don't forget what you said.`);
    vanessa.talk(`Have fun with doofus.`);
    ImageClass.setImage(images.v4.BarAnnAloneNoDrinks);
    ann.talk(`You see what I was dealing with... Thanks for coming.`);
    mc.talk(`Is she always like that?`);
    ann.talk(`More or less.`);
    ann.talk(`She is acting like the drunk Vanessa I know.`);
    ann.talk(`We never go out to places like this.`);
    ann.talk(`She just used to come over drunk after she was partying with friends or whatever.`);
    return jump(ClubEventWithoutJoeInsideVanessaDancing2, "ClubEventWithoutJoeInsideVanessaDancing2");

};

export const ClubEventWithoutJoeInsideVanessaDancing2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneNoDrinks);
    ann.talk(`So, before Vanessa interrupted us, I was just about to ask.`);
    if (Question.globalAnswers.v4WithoutJoeyLiedToAnn) {
        ann.talk(`Why did you force Vanessa to do what she did...`);
        if (mc.properties.vanessaRelationship > 5) {
            mc.talk(`I really like her.`);
            ann.talk(`Ok...`);
            ann.talk(`Weird thing to do but fine. I guess that's how men's minds work.`);
        } else {

            mc.talk(`I don't know... It just felt like the right thing to do.`);
            ann.talk(`Ok...`);
        }

        ann.talk(`Can I say something?`);
        mc.talk(`Sure.`);
        ann.talk(`I don't want to sound rude, but what you did really turned me off...`);
        ann.talk(`I really thought you were different.`);
        if (Question.globalAnswers.v1AnnFirstCall === "straight_forward") {

            ann.talk(`But I should have known.`);
            ann.talk(`Especially after we talked on the phone.`);
            ann.talk(`You were straight forward about what you want.`);
            ann.talk(`But you never did something wrong to me, so... Yeah...`);
            ann.talk(`Let's just change the subject.`);
            mc.talk(`Alright.`);
        } else {
            ann.talk(`Especially after we talked on the phone.`);
            ann.talk(`You sounded so insecure.`);
            ann.talk(`I guess it was all an act.`);
            mc.talk(`It wasn't an act.`);
            ann.talk(`You are acting differently now.`);
            mc.talk(`I'm just not used to call a girl I don't know and ask her out...`);
            ann.talk(`Oh. It kinda makes sense.`);
        }
    } else {
        ann.talk(`You need to fix your relationship with Joe.`);
        mc.talk(`Don't worry about that.`);
        ann.talk(`But I am...`);
        mc.talk(`Why? You haven't really known us for that long.`);
        ann.talk(`It's a sad thing that two good friends become enemies because of a girl...`);
        ann.talk(`And to be honest, I've seen it before.`);
        mc.talk(`I'm sure it's going to be fine, I just need to give him some time.`);
    }
    return jump(ClubEventJoeInsideAnnAloneStatus01InstaTalk, "ClubEventJoeInsideAnnAloneStatus01InstaTalk");

};
export const ClubEventWithoutJoeInsideVanessaDancing3 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnChris2_2, { duration: 0.6 });
    chris.talk(`Hey guys is everything ok?`);
    if (Question.globalAnswers.v4WithoutJoeyLiedToAnn) {
        chris.talk(`It looks like you are having a serious conversation.`);
        ImageClass.setImage(images.v4.BarAnnChris_2);
        ann.talk(`It's ok.`);
    } else {

        mc.talk(`Yes, we are fine.`);
    }
    ImageClass.setImage(images.v4.BarAnnChris_2);
    chris.talk(`Vanessa asked me to give you guys some shots.`);
    ann.talk(`Ah...`);
    ImageClass.setImage(images.v4.BarAnnChris3);
    chris.talk(`Don't worry, it's on me.`);
    chris.talk(`Ann, Vanessa insisted that you drink it, she said you owe her.`);
    mc.think(`He brought two shots... Why would Vanessa order some for me... She is pissed at me.`);
    chris.talk(`Enjoy!`);
    ImageClass.setImage(images.v4.BarAnnAloneBeforeDrinks);
    ann.talk(`I don't know... I still feel the effect of the previous one...`);
    await ann.setQuestion(new Question({ text: `I never drink. It's too much for me.`, options: { think: false }, key: `v4WithoutJoeyToldAnnToSpillDrinkFloor` })
        .option({ title: `Let's drink`, key: false })
        .option({ title: `Spill it on the floor`, key: true }));


    if (Question.globalAnswers.v4WithoutJoeyToldAnnToSpillDrinkFloor) {
        await ann.set((properties) => {
            properties.v4DrankDrug = false;
        });
        return jump(ClubEventWithoutJoeInsideVanessaDancingSpill, "ClubEventWithoutJoeInsideVanessaDancingSpill");
    } else {
        await ann.set((properties) => {
            properties.v4DrankDrug = true;
            properties.v4JoeyBirthdayDrinksNum++;
        });
        return jump(ClubEventWithoutJoeInsideVanessaDancingDrink, "ClubEventWithoutJoeInsideVanessaDancingDrink");
    }

};

export const ClubEventWithoutJoeInsideVanessaDancingDrink = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneBeforeDrinks);
    mc.talk(`Let's drink it, what can happen?`);
    ann.talk(`I've seen videos...`);
    mc.talk(`It's only a shot. And you promised Vanessa.`);
    ann.talk(`Well... Fine.`);
    mc.talk(`Cheers.`);
    ImageClass.setImage(images.v4.BarAnnAloneDrinking, { wait: true });
    return jump(ClubEventWithoutJoeInsideGoToVanessaAfter, "ClubEventWithoutJoeInsideGoToVanessaAfter");
};

export const ClubEventWithoutJoeInsideVanessaDancingSpill = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneBeforeDrinks);
    mc.talk(`Just spill it on the floor, she won't see.`);
    ann.talk(`Good idea, but Chris might see me.`);
    mc.talk(`He isn't looking. Do it now quickly.`);
    ImageClass.setImage(images.v4.BarAnnSpillingDrink);
    ann.talk(`Done!`);
    return jump(ClubEventWithoutJoeInsideGoToVanessaAfter, "ClubEventWithoutJoeInsideGoToVanessaAfter");
};

export const ClubEventWithoutJoeInsideGoToVanessaAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks);
    if (ann.properties.v4JoeyBirthdayDrinksNum > 1) {

        ann.talk(`Wow... I can feel my head spinning already.`);
        mc.talk(`Haha, it doesn't work like that. You need to give it a few minutes.`);
        ann.talk(`I think tilting my head made me dizzy as well.`);
    } else {

    }
    return jump(ClubEventJoeInsideAnnAloneStatus0, "ClubEventJoeInsideAnnAloneStatus0");
};

export const ClubEventWithoutJoeInsideGoToVanessa = async (): Promise<any> => {

    if (ann.properties.v4DrankDrug) {
        if (mc.properties.annLateGF) {
            ImageClass.setImage(images.v4.BarAnnKiss2);
            ann.talk(`I wanted you since I first saw you.`);
            ann.talk(`I've never admitted to liking anyone, I hope I'm not scaring you.`);
            mc.talk(`You aren't.`);
            ann.talk(`I just felt a huge urge to kiss you I hope that's ok.`);
        } else {
            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks);
            ann.talk(`I'm sorry.`);
        }

        ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks);
        ann.talk(`I usually stop myself from doing the stuff I want to do...`);
        mc.think(`The alcohol really effects her.`);
    }
    ann.talk(`I need to wash my face but I am so dizzy.`);
    ann.talk(`Can you call Vanessa please to help me out?`);
    mc.talk(`Sure.`);

    if (!ann.properties.v4DrankDrug) {
        if (mc.properties.annLateGF) {
            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks2);
            ann.talk(`Can you give me a few seconds?`);
            ann.talk(`I need to go to the restroom but I don't want to go alone.`);
            ann.talk(`Do you see Vanessa by any chance?`);
            mc.talk(`Yes, I see her dancing.`);
            ann.talk(`Can you call her, please?`);
            mc.talk(`Alright.`);
        } else if (mc.properties.annLateHate) {
            ImageClass.setImage(images.v4.BarAnnAloneAfterDrinks_Sad);
            ann.talk(`${mc.name}...`);
            ann.talk(`I promised myself that I wouldn't care whatever your answer will be...`);
            ann.talk(`But it still made me a bit sad...`);
            ann.talk(`I want to go home now...`);
            mc.talk(`Are you sure?`);
            ann.talk(`Yes... Please, just do me this last favor and call her...`);
        }
    }

    mc.talk(`Be right back.`);
    ImageClass.setImage(images.v4.VanessaDancing1, { transition: true });
    mc.think(`Vanessa is dancing at the dance floor.`);
    mc.think(`It seems like she forgot all about Joey already.`);
    mc.talk(`Vanessa.`);
    ImageClass.setImage(images.v4.VanessaDancing2);
    vanessa.talk(`Doofus!`);
    vanessa.talk(`Come! Dance with me.`);
    mc.talk(`Ann is calling you.`);
    vanessa.talk(`What does she want?`);
    if (ann.properties.v4DrankDrug) {
        mc.talk(`She needs to go to the restroom and she doesn't want to go alone.`);
        if (Question.globalAnswers.v1EnableNTR && !mc.properties.annLateGF) {
            vanessa.talk(`Well, I don't think she needs to go anymore.`);
            mc.talk(`What?`);
            vanessa.talk(`Turn around.`);

            ImageClass.setImage(images.v4.BarChrisAnnKissingFar);
            mc.think(`What the fuck?`);
            mc.think(`I bet that's what they were planning.`);
            ImageClass.setImage(images.v4.VanessaDancing2);
            vanessa.talk(`Can you believe it? Ann is getting some action.`);
            vanessa.talk(`You better run over there and stop this madness.`);
            vanessa.talk(`But do you really care about her?`);
            vanessa.talk(`I know what you really want.`);
            mc.talk(`What's that?`);
        } else {
            vanessa.talk(`It looks like Ann is doing fine without you.`);
            mc.talk(`Huh?`);
            vanessa.talk(`Turn around.`);
            ImageClass.setImage(images.v4.BarChrisAnnTalking);
            mc.think(`Where did he come from?`);
            if (mc.properties.annLateHate) {
                mc.think(`She was sad just a few seconds ago...`);

            }
            ImageClass.setImage(images.v4.VanessaDancing2);
            vanessa.talk(`You better run over there before they will do something.`);
            vanessa.talk(`But before you do.`);
            vanessa.talk(`Do you really care about her?`);
            vanessa.talk(`I know what you really want.`);
            mc.talk(`What's that?`);
        }


    } else {
        if (mc.properties.annLateHate) {
            mc.talk(`She wants to go home.`);
            vanessa.talk(`Why? What did you do?`);
            mc.talk(`It doesn't matter.`);
            vanessa.talk(`You really are a doofus!`);
            vanessa.talk(`Anyway, it doesn't matter now.`);
            vanessa.talk(`I don't think she needs to go anymore.`);
        } else if (mc.properties.annLateGF) {
            mc.talk(`She needs to go to the restroom and she doesn't want to go alone.`);
            vanessa.talk(`Well, looks like she doesn't need to go anymore.`);
        }
        mc.talk(`Huh?`);
        vanessa.talk(`Turn around.`);
        ImageClass.setImage(images.v4.BarChrisAnnTalking);
        vanessa.talk(`You better run over there before they will do something.`);
        vanessa.talk(`But before you do.`);
        vanessa.talk(`Do you really care about her?`);
        vanessa.talk(`I know what you really want.`);
        mc.talk(`What's that?`);

    }

    return jump(ClubEventWithoutJoeInsideGoToVanessaQuestion, "ClubEventWithoutJoeInsideGoToVanessaQuestion");

};
export const ClubEventWithoutJoeInsideGoToVanessaQuestion = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarGoWithVanessa1);
    await vanessa.setQuestion(new Question({ text: `Follow me and I'll show you.`, options: { think: false }, key: `v4FollowedVanessaToAlley` })
        .option({ title: `Go with Vanessa`, key: true })
        .option({ title: `Go to Ann`, key: false }));


    if (Question.globalAnswers.v4FollowedVanessaToAlley) {
        return jump(ClubEventWithoutJoeInsideGoToVanessa2, "ClubEventWithoutJoeInsideGoToVanessa2");

    } else {
        mc.talk(`Nah, I'd rather go to Ann.`);
        return jump(ClubEventWithoutJoeInsideGoToAnnChris, "ClubEventWithoutJoeInsideGoToAnnChris");

    }
};


export const ClubEventWithoutJoeInsideGoToVanessa2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarGoWithVanessa1);
    mc.talk(`Let's go.`);
    vanessa.talk(`Amazing decision!`);
    ImageClass.setImage(images.v4.BarGoWithVanessa2);
    mc.think(`Not long ago she was furious with me...`);
    mc.think(`I hope I am not going to regret it.`);
    mc.talk(`Where are we going?`);
    vanessa.talk(`You'll see.`);
    ImageClass.setImage(images.v4.BarGoWithVanessa3, { duration: 0.8 });
    mc.think(`She is leading me to an alley behind the bar.`);
    vanessa.talk(`Almost there.`);
    ImageClass.setImage(images.v4.BarVanessaAlley1, { duration: 0.8 });
    vanessa.talk(`Here we are!`);
    vanessa.talk(`Sit on the box.`);
    mc.think(`I made it this far, I might as well do as she says.`);
    ImageClass.setImage(images.v4.BarVanessaAlley2);
    mc.talk(`What are we doing here?`);
    vanessa.talk(`I wanted some alone time with you.`);
    vanessa.talk(`Even though it was very stupid of you to tell Joe our little secret I don't want us to be enemies.`);
    vanessa.talk(`And I know why you did it.`);
    vanessa.talk(`I've seen the way you look at me.`);
    ImageClass.setImage(images.v4.BarVanessaAlley8);
    vanessa.talk(`I know you are always staring at my ass.`);
    vanessa.talk(`You must like it.`);
    ImageClass.setImage(images.v4.BarVanessaAlley9);
    vanessa.talk(`And my boobs.`);
    if (Question.globalAnswers.todMCDareVanessa == "showBoobs") {
        vanessa.talk(`You dared me to show them to you, but I bet it wasn't enough for you.`);

    } else {

    }
    vanessa.talk(`I'm sorry for not making you cum, you must be really horny.`);
    vanessa.talk(`Take your dick out and masturbate for me.`);
    ImageClass.setImage(images.v4.BarVanessaAlley5);
    vanessa.talk(`There you go.\nI missed it already.`);
    vanessa.talk(`Wait here.`);
    ImageClass.setImage(images.v4.BarVanessaAlley10);
    mc.think(`What the fuck? Where did she go?`);
    mc.think(`I have a bad feeling about that...`);
    return jump(ClubEventWithoutJoeInsideGoToVanessaStay, "ClubEventWithoutJoeInsideGoToVanessaStay");
};

export const ClubEventWithoutJoeInsideGoToVanessaStay = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarVanessaAlley3, { duration: 1 });
    vanessa.talk(`I'm back!`);
    mc.talk(`What? Who is that?`);
    vanessa.talk(`That's Rock.`);
    ImageClass.setImage(images.v4.BarVanessaAlley4);
    rick.talk(`Rick.`);
    ImageClass.setImage(images.v4.BarVanessaAlley3);
    vanessa.talk(`That's Rick.`);
    ImageClass.setImage(images.v4.BarVanessaAlley4);
    rick.talk(`Why is there a dude here with his dick out?`);
    await vanessa.setQuestion(new Question({ text: `That's my friend, he is going to masturbate while I'm sucking your dick.`, options: { think: false }, key: `v4StayedWithVanessaAlleyBJ` })
        .option({ title: `Stay`, key: true })
        .option({ title: `Hell no, I'm out`, key: false }));


    if (Question.globalAnswers.v4StayedWithVanessaAlleyBJ) {
        return jump(ClubEventWithoutJoeInsideVanessaBJStay, "ClubEventWithoutJoeInsideVanessaBJStay");

    } else {
        return jump(ClubEventWithoutJoeInsideVanessaBJLeave, "ClubEventWithoutJoeInsideVanessaBJLeave");

    }
};

export const ClubEventWithoutJoeInsideVanessaBJStay = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarVanessaAlley4);
    mc.think(`I should have known better, she is always teasing me.`);
    mc.think(`I might as well enjoy the show.`);
    vanessa.talk(`Are you waiting for an official invitation?`);
    rick.talk(`Huh?`);
    vanessa.talk(`Jeez... Take your pants off already.`);
    ImageClass.setImage(images.v4.BarVanessaAlley6);
    vanessa.talk(`Damn... I thought you'd be bigger.`);
    vanessa.talk(`But this will do.`);
    ImageClass.setImage(images.v4.BarVanessaAlley7, { transition: true });
    vanessa.talk(`I'm glad you stayed.`);
    ImageClass.setImage(images.v4.BarVanessaAlley13, { wait: true });
    ImageClass.setImage(images.v4.BarVanessaAlley14, { wait: true });
    ImageClass.setImage(images.v4.BarVanessaAlley13, { wait: true });
    ImageClass.setImage(images.v4.BarVanessaAlley12);
    vanessa.talk(`I hope it turns you on!`);
    vanessa.talk(`The small dick ruined my plan.`);
    rick.talk(`Why did you stop? Keep going.`);
    ImageClass.setImage(images.v4.BarVanessaAlley16);
    vanessa.talk(`RUDEEE!! I'm talking!`);
    rick.talk(`I am not a guy you can play with.`);
    vanessa.talk(`Fineeee!`);
    ImageClass.setImage(images.v4.BarVanessaAlley13, { wait: true });
    ImageClass.setImage(images.v4.BarVanessaAlley14, { wait: true });
    ImageClass.setImage(images.v4.BarVanessaAlley17);
    mc.think(`She is giving me a nasty look while she is deepthroating him.`);
    mc.think(`Not that it's hard for her...`);
    ImageClass.setImage(images.v4.BarVanessaAlley12);
    vanessa.talk(`Have you seen the weather forecast for tomorrow?`);
    vanessa.talk(`It's going to be really sunny! I think I'll go and get a tan.`);
    mc.talk(`Aren't you suppose to tease me?`);
    vanessa.talk(`That was my plan but he annoyed me.`);

    ImageClass.setImage(images.v4.BarVanessaAlley15);
    rick.talk(`Bitch, I told you not to play games with me.`);

    return jump(ClubEventWithoutJoeInsideVanessaBJStay2, "ClubEventWithoutJoeInsideVanessaBJStay2");
};

export const ClubEventWithoutJoeInsideVanessaBJStay2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.Pre_V4VanessaAlleyBJ, { duration: 0.6 });
    rick.talk(`Small dick or not, you are going to make me cum.`);
    ImageClass.setAnimation(images.v4.Anim_V4VanessaAlleyBJ);
    vanessa.talk(`Slurp.`);
    vanessa.talk(`MMM...`);
    vanessa.talk(`Slurp!`);
    ImageClass.setAnimation(images.v4.Anim_V4VanessaAlleyBJ, { speed: 1.5 });
    rick.talk(`How do you like the weather now huh??`);
    vanessa.talk(`SLURP!`);
    rick.talk(`That's right.`);
    rick.talk(`Bitch!`);

    ImageClass.setImage(images.v4.BarVanessaAlley19, { duration: 0.6 });
    rick.talk(`AHHH!!!!`);
    ImageClass.setImage(images.v4.BarVanessaAlley15);
    rick.talk(`Now you can talk with him about anything you want.`);
    ImageClass.setImage(images.v4.BarVanessaAlley20);
    vanessa.talk(`Mmm...`);
    ImageClass.setImage(images.v4.BarVanessaAlley5_2);
    mc.think(`FUCK!`);
    mc.think(`I don't know if that was exactly her plan, but it was kinda hot.`);
    ImageClass.setImage(images.v4.BarVanessaAlley21);
    mc.think(`I guess the show is over.`);
    ImageClass.setImage(images.v4.BarVanessaAlley10, { duration: 0.8 });
    mc.think(`She waved goodbye and left.`);
    mc.think(`I think she still had his cum in her mouth.`);
    mc.think(`Damn, she is nuts.`);
    mc.think(`I should have known she isn't going to blow me after what I did.`);
    mc.think(`But at least I got to see her up close and in action.`);
    await endReplay(replayScenesList.v4VanessaAlleyBlowjob);
    return jump(ClubEventWithoutJoeInsideVanessaBJStayBackToAnn, "ClubEventWithoutJoeInsideVanessaBJStayBackToAnn");
};

export const ClubEventWithoutJoeInsideVanessaBJLeave = async (): Promise<any> => {
    await endReplay();
    ImageClass.setImage(images.v4.BarVanessaAlley4);
    mc.talk(`Hell no! I'm out.`);
    ImageClass.setImage(images.v4.BarVanessaAlley3);
    vanessa.talk(`Wait! It's going to be fun!`);
    ImageClass.setImage(images.v4.BarVanessaAlley4);
    rick.talk(`Does that mean I'm not getting a blowjob?`);
    if (mc.properties.annLateHate) {
        if (Question.globalAnswers.v1EnableNTR && ann.properties.v4DrankDrug) {
            ImageClass.setImage(images.v4.Car1);
            mc.think(`Fuck that, I'm not going to watch her sucking some dude's cock.`);
            mc.think(`I wonder if Ann saw me walking away with Vanessa.`);
            mc.think(`Wait, what's that?`);
            return jump(ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar, "ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar");

        }
        ImageClass.setImage(images.v4.BarAlone);
        mc.think(`Ann is not here anymore.`);
        mc.think(`She was with Chris before I left.`);
        mc.think(`Maybe she saw me going away with Vanessa so she left with him.`);
        mc.think(`Nothing else to do in this place, I better go home.`);
        return jump(ClubHome, "ClubHome");
    } else {

    }
    mc.think(`I'll just get back to Ann.`);

    return jump(ClubEventWithoutJoeInsideVanessaBJStayBackToAnn, "ClubEventWithoutJoeInsideVanessaBJStayBackToAnn");
};
export const ClubEventWithoutJoeInsideGoToAnnChris = async (): Promise<any> => {
    if (Question.globalAnswers.v1EnableNTR) {
        if (mc.properties.annLateGF) {

            ImageClass.setImage(images.v4.BarAnnChrisClose2);
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisKiss);
        }
    } else {

        ImageClass.setImage(images.v4.BarAnnChrisClose2);
    }

    await mc.setQuestion(new Question({ text: `They didn't even notice me.`, options: { think: true }, key: `v4WithoutJoeyMCBackReactToAnnChris` })
        .option({ title: `Get angry at Chris`, key: `getAngryAtChris` })
        .option({ title: `Get angry at Ann`, key: `getAngryAtAnn` })
        .option({ title: `Say nothing`, key: `sayNothing` }));


    if (Question.globalAnswers.v4WithoutJoeyMCBackReactToAnnChris === "getAngryAtChris") {
        await mc.set((properties) => {
            properties.alpha++;
        });
        mc.talk(`Chris, what the fuck do you think you are doing?`);
        if (ann.properties.v4DrankDrug) {

            ImageClass.setImage(images.v4.BarAnnChrisClose1);
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose3);
        }
        if (mc.properties.annLateGF) {

            chris.talk(`Chill bro, we are just talking.`);
        } else if (mc.properties.annLateHate) {
            if (Question.globalAnswers.v1EnableNTR && ann.properties.v4DrankDrug) {
                chris.talk(`Chill bro, I just came over to ask if everything is fine and she jumped on me.`);

            } else {

                chris.talk(`Chill bro, we are just talking.`);
            }

        }


    } else if (Question.globalAnswers.v4WithoutJoeyMCBackReactToAnnChris === "getAngryAtAnn") {
        await mc.set((properties) => {
            properties.alpha++;
        });
        mc.talk(`Ann, what the fuck?`);
        if (ann.properties.v4DrankDrug) {

            ImageClass.setImage(images.v4.BarAnnChrisClose1);
        } else {

            ImageClass.setImage(images.v4.BarAnnChrisClose3);
        }
        if (mc.properties.annLateGF) {

            ann.talk(`What?`);
            mc.talk(`What do you mean by "What"?!`);
            mc.talk(`What is he doing here?`);
            ann.talk(`He just came over to ask if everything is alright.`);
            chris.talk(`Hey, chill you don't need to get angry.`);
        } else if (mc.properties.annLateHate) {

            if (Question.globalAnswers.v1EnableNTR && ann.properties.v4DrankDrug) {
                ann.talk(`You don't like me so I found someone better, hehe.`);
                mc.think(`What's going on with her? It's not like her at all.`);
            } else {

                ann.talk(`Why do you care?`);
                ann.talk(`You don't care about me.`);
            }
        }
    } else {
        await mc.set((properties) => {
            properties.alpha--;
        });
        if (mc.properties.annLateHate) {

            if (Question.globalAnswers.v1EnableNTR && ann.properties.v4DrankDrug) {

                mc.think(`I know that I just turned her down, but it's not like her to kiss some random guy...`);
                mc.think(`I believe she just met him today.`);
            }
        }

    }

    if (mc.properties.annLateHate && !ann.properties.v4DrankDrug) {

        ImageClass.setImage(images.v4.BarAnnChrisClose2);
        ann.talk(`Chris, can you take me home?`);
        ann.talk(`I don't feel like staying here.`);
        chris.talk(`Sure, my car parks outside and my shift is almost over, but we can leave right now.`);
        chris.talk(`Let's go.`);
        ImageClass.setImage(images.v4.BarAlone);
        mc.think(`She doesn't even know him yet she left with him...`);
        return jump(ClubHome, "ClubHome");
    } else {

    }
    if (Question.globalAnswers.v1EnableNTR || mc.properties.annLateHate) {
        return jump(ClubEventWithoutJoeInsideGoToAnnChrisTODAgree, "ClubEventWithoutJoeInsideGoToAnnChrisTODAgree");

    } else {

    }
    return jump(ClubEventWithoutJoeInsideGoToAnnChrisTODNotAgreeStatus4, "ClubEventWithoutJoeInsideGoToAnnChrisTODNotAgreeStatus4");

};
export const ClubEventWithoutJoeInsideGoToAnnChrisTODNotAgreeStatus4 = async (): Promise<any> => {
    if (ann.properties.v4DrankDrug) {

        ImageClass.setImage(images.v4.BarAnnChrisClose1);
    } else {

        ImageClass.setImage(images.v4.BarAnnChrisClose3);
    }

    chris.talk(`Hey dude, I was just checking if everything is good.`);
    chris.talk(`I'll get out of your way.`);
    chris.talk(`Just call me if you need anything.`);
    if (!ann.properties.v4DrankDrug) {
        ImageClass.setImage(images.v4.BarAnnAloneNoVan1);
        if (Question.globalAnswers.v4WithoutJoeyMCBackReactToAnnChris === "getAngryAtAnn" || Question.globalAnswers.v4WithoutJoeyMCBackReactToAnnChris === "getAngryAtChris") {

            ann.talk(`I didn't think you will get upset...`);
            ann.talk(`I would have told him to leave if I knew.`);
            mc.talk(`Forget about that.`);
        }
        ann.talk(`So, ${mc.name}, tell me something interesting!`);

    } else if (ann.properties.v4DrankDrug === true) {
        ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
        ann.talk(`${mc.name}, you are so jealous, hehe.`);
        ImageClass.setImage(images.v4.BarAnnKiss2);
        ann.talk(`I like it, that you like me so much.`);
        ImageClass.setImage(images.v4.BarAnnKissAlone);
        ann.talk(`Muah.`);
    }
    return jump(ClubHome, "ClubHome");
};
export const ClubEventWithoutJoeInsideGoToAnnChrisTODAgree = async (): Promise<any> => {
    if (ann.properties.v4DrankDrug) {

        ImageClass.setImage(images.v4.BarAnnChrisClose1_NoVan);
    } else {

        ImageClass.setImage(images.v4.BarAnnChrisClose3_NoVan);
    }
    ann.talk(`Where is Vanessa?`);
    mc.talk(`She doesn't want to come.`);
    ann.talk(`Oh... I'll go by myself then.`);
    ann.talk(`Be right back!`);
    ImageClass.setImage(images.v4.BarChrisAloneSitting);
    chris.talk(`Hey dude.`);
    if (Question.globalAnswers.v4WithoutJoeyMCBackReactToAnnChris === "getAngryAtChris" || Question.globalAnswers.v4WithoutJoeyMCBackReactToAnnChris === "getAngryAtAnn") {

        chris.talk(`Sorry man, I didn't mean to step on your toes.`);
        chris.talk(`I saw her by herself so I came to ask her if she was doing alright.`);
    } else {

    }

    if (ann.properties.v4DrankDrug && mc.properties.annLateHate) {
        chris.talk(`I didn't know she would start kissing me.`);
        mc.think(`He doesn't even know I turned her down a few seconds ago.`);
        if (Question.globalAnswers.v4WithoutJoeyMCBackReactToAnnChris === "sayNothing") {

            chris.talk(`I hope you are not mad.`);
        }

    }
    mc.think(`This can be my only chance to find out what Vanessa and he were planning.`);
    mc.think(`I can try and get him to talk if he doesn't, I can always tell him to fuck off.`);
    mc.talk(`I saw that you and Vanessa are getting along nicely.`);
    chris.talk(`Oh... I figure that you saw that we were talking about you.`);
    mc.talk(`It was hard to miss.`);
    mc.talk(`What were you talking about?`);
    chris.talk(`She told me what you did.`);
    chris.talk(`You know... Forcing her to blow you.`);
    chris.talk(`I must say, that was bold of you.`);
    chris.talk(`But she does give a nice head, doesn't she? Haha.`);
    mc.talk(`Yes, she does.`);
    chris.talk(`Can I ask you a question?`);
    mc.talk(`Sure.`);
    return jump(ClubEventWithoutJoeInsideGoToAnnChrisTODAgree2, "ClubEventWithoutJoeInsideGoToAnnChrisTODAgree2");
};

export const ClubEventWithoutJoeInsideGoToAnnChrisTODAgree2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarChrisAloneSitting);
    await chris.setQuestion(new Question({ text: `Do you always hang out with hot chicks?`, options: { think: false }, key: `v4NoJoeyWasMeanToChris` })
        .option({ title: `Be mean`, key: true })
        .option({ title: `Be nice`, key: false }));


    if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {
        await mc.set((properties) => {
            properties.mean++;
            properties.alpha += 2;
            properties.chrisStatus = "enemy";
        });
        mc.talk(`That's none of your business.`);
        ImageClass.setImage(images.v4.BarChrisAloneSitting_1);
        chris.talk(`No need to be an asshole.`);
        mc.think(`Wow, that's an ugly angry face.`);
        mc.talk(`I can do whatever I want.`);
        mc.talk(`What are you doing here anyway? Don't you have a bar to tend?`);
        chris.talk(`Enjoy the rest of the night.\nCya.`);
    } else {
        await mc.set((properties) => {
            properties.mean--;
            properties.chrisStatus = "friend";
        });
        mc.talk(`Lately yes, why?`);
        chris.talk(`Well, how can I put this?`);
        chris.talk(`Like you know, I meet all kinds of people in my line of work.`);
        chris.talk(`But sometimes I want to meet girls that bars aren't their usual hangout place.`);
        chris.talk(`What I want to say is, if you throw me a bone I'll throw you one as well.`);
        chris.talk(`In other words, I'll be happy to point the girls I meet in your direction once I'm done with them as long as you do the same.`);

        return jump(ClubEventWithoutJoeInsideGoToAnnChrisTODAgree2_Question2, "ClubEventWithoutJoeInsideGoToAnnChrisTODAgree2_Question2");
    }
    return jump(ClubEventWithoutJoeInsideGoToAnnChrisTODAgreeAfter, "ClubEventWithoutJoeInsideGoToAnnChrisTODAgreeAfter");
};
export const ClubEventWithoutJoeInsideGoToAnnChrisTODAgree2_Question2 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarChrisAloneSitting);
    await chris.setQuestion(new Question({ text: `What do you say?`, options: { think: false }, key: `v4AgreedToChrisProposal` })
        .option({ title: `Agree`, key: true })
        .option({ title: `Disagree`, key: false }));


    if (Question.globalAnswers.v4AgreedToChrisProposal) {
        await mc.set((properties) => {
            properties.agreeToChrisProposal = true;
        });
        mc.talk(`Sure, why not?`);
        ImageClass.setImage(images.v4.BarChrisAloneSitting_2);
        chris.talk(`Great!`);
        chris.talk(`It's the start of a great friendship.`);
        chris.talk(`Listen, I got to tell you something.`);
        ImageClass.setImage(images.v4.BarChrisAloneSitting);
        chris.talk(`I promised Vanessa that I won't say a word, but you are a really cool dude.`);
        mc.talk(`What is it?`);

        chris.talk(`I wasn't completely honest.`);
        chris.talk(`When Vanessa and I were talking she was mentioning something about planning a surprise for you.`);
        mc.talk(`Surprise?`);
        chris.talk(`Yes, and not a pleasant one.`);
        chris.talk(`She also asked me to keep Ann busy when I see her alone.`);

        chris.talk(`But since you are here I guess that her plan didn't work.`);
        mc.talk(`She wasn't convincing enough for me to go with her.`);
        chris.talk(`I think it's for the best.`);
        chris.talk(`I don't really know her for that long but that girl is crazy.`);
        mc.talk(`Yeah... You aren't wrong about that.`);
        chris.talk(`Well, anyway dude.`);
        chris.talk(`I need to get back to work.`);

        chris.talk(`It was nice talking to you.`);
        mc.talk(`Thanks, you too.`);
    } else {
        await mc.set((properties) => {
            properties.agreeToChrisProposal = false;
        }); mc.talk(`You should meet your girls by yourself.`);
        chris.talk(`Alright, dude.`);
        chris.talk(`I was just asking.`);

        chris.talk(`It could have been the start of a great friendship.`);
        chris.talk(`Enjoy the rest of the night.`);
    }

    return jump(ClubEventWithoutJoeInsideGoToAnnChrisTODAgreeAfter, "ClubEventWithoutJoeInsideGoToAnnChrisTODAgreeAfter");
};
export const ClubEventWithoutJoeInsideGoToAnnChrisTODAgreeAfter = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAlone);
    if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {

        mc.think(`What a jerk.`);
    } else if (Question.globalAnswers.v4NoJoeyWasMeanToChris === false) {
        mc.think(`He is a cool dude.`);
        if (mc.properties.agreeToChrisProposal) {

            mc.think(`He works as a bartender, I bet he meets all kind of girls.`);
            mc.think(`I think I made the right decision.`);
        } else if (mc.properties.agreeToChrisProposal === false) {
            mc.think(`But what the fuck does he think I am?`);
            mc.think(`I am not going to send girls his way.`);
        }

    }

    if (mc.properties.annLateHate) {
        return jump(ClubEventWithoutJoeInsideGoToAnnTODAgreeAloneStatus5, "ClubEventWithoutJoeInsideGoToAnnTODAgreeAloneStatus5");

    }
    if (ann.properties.v4DrankDrug) {

        ImageClass.setImage(images.v4.BarAnnAloneNoVan2);
    } else {

        ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
    }

    ann.talk(`I am back!`);
    ann.talk(`I hope you and Chris were getting along.`);
    mc.talk(`You can say that.`);
    ann.talk(`What did you talk about?`);
    mc.talk(`Guy talk.`);
    ann.talk(`Oh ok, hehe.`);
    return jump(ClubHome, "ClubHome");

};
export const ClubEventWithoutJoeInsideGoToAnnTODAgreeAloneStatus5 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAlone, { transition: true });
    mc.think(`It's been a while now, where is she?`);
    mc.think(`I hope nothing happened to her.`);
    mc.think(`I better go look for her.`);
    ImageClass.setImage(images.v4.ToiletVanessaAnn);
    mc.talk(`Ann?`);
    mc.think(`She is not here.`);
    await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann2 }, async () => {
        Phone.setMessage({ character: mc.character, text: `Ann?`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `Where are you?` });
        Phone.setMessage({ character: mc.character, text: `Is everything ok?` });
        Phone.talk({ text: `No answer...`, character: mc.character });
        Phone.closeMessagesUI();
    });

    if (ann.properties.v4DrankDrug) {
        mc.think(`Maybe she is outside.`);
        return jump(ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar, "ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar");

    }
    mc.talk(`I can't find her anywhere.`);
    mc.talk(`I hope she is fine...`);
    mc.talk(`I'll go home and hope she responds to my texts.`);
    return jump(ClubHome, "ClubHome");

};

export const ClubEventWithoutJoeInsideVanessaBJStayBackToAnn = async (): Promise<any> => {
    await endReplay();
    ImageClass.setImage(images.v4.BarVanessaAlley10);
    if (mc.properties.annLateGF) {
        if (!Game.seenScenarios.includes(`ClubEventWithoutJoeInsideVanessaBJLeave`)) {

            mc.think(`Shit! Ann!`);
            mc.think(`I completely forgot about her.`);
            mc.think(`I hope she is still waiting for me.`);
        }
        if (ann.properties.v4DrankDrug) {
            ImageClass.setImage(images.v4.BarAnnAloneNoVan2, { transition: true });

        } else {
            ImageClass.setImage(images.v4.BarAnnAloneNoVan1, { transition: true });

        }
        mc.talk(`Hey Ann.`);
        ann.talk(`Where have you been?`);
        ann.talk(`I told you to call Vanessa and you never came back.`);
        mc.talk(`Yeah... She wanted to show me something.`);
        await ann.setQuestion(new Question({ text: `What?`, options: { think: false }, key: `v4ToldAnnTruthWentToAlleyWithVanessa` })
            .option({ title: `Tell the truth`, key: true })
            .option({ title: `Lie`, key: false }));


        if (Question.globalAnswers.v4ToldAnnTruthWentToAlleyWithVanessa) {
            await mc.set((properties) => {
                properties.liar--;
            });
            mc.talk(`She tricked me to to go with her to an alley.`);
            if (Game.seenScenarios.includes(`ClubEventWithoutJoeInsideVanessaBJLeave`)) {
                mc.talk(`Then she called this guy over and wanted me to watch her suck his dick.`);
                mc.talk(`But I said fuck that and left.`);
            } else {
                mc.talk(`Then she called this guy over and sucked his dick while I was watching.`);

            }
            if (ann.properties.v4DrankDrug) {
                ann.talk(`Hehe, oh my God! She is so stupid.`);
                ann.talk(`I can't believe you fell for that.`);
                mc.talk(`Does she do it all the time?`);
                ann.talk(`I don't know...`);
                ann.talk(`Maybe she does, maybe she doesn't.`);
                mc.talk(`Great answer.`);
                ann.talk(`Hehe.`);
                mc.think(`She is too drunk to have a serious conversation.`);
            } else {
                ann.talk(`Are you serious?`);
                mc.talk(`Yes.`);
                ann.talk(`Don't you learn?`);
                ann.talk(`She is playing you, and you lost Joe because of it.`);
                mc.talk(`Joey was kinda my fault.`);
                ann.talk(`Maybe, but it wouldn't have happened if she wasn't in the picture.`);
                mc.talk(`Let's just change the subject, I don't feel like talking about that right now.`);

            }
        } else {
            await mc.set((properties) => {
                properties.liar++;
            });
            mc.talk(`Nothing, we were just talking.`);
            if (ann.properties.v4DrankDrug) {
                ann.talk(`Hehe, ok.`);

            } else {
                ann.talk(`About what?`);
                mc.talk(`About what happened... Nothing interesting.`);
                ann.talk(`Do you have a plan on how to be a friend of Joe again?`);
                mc.talk(`Not yet.`);
                ann.talk(`Oh... Ok.`);
            }

        }
        mc.talk(`Didn't you need to go to the restroom?`);
        ann.talk(`I already went...`);
        mc.talk(`Oh ok.`);
        ann.talk(`Let's just forget about that.`);
        mc.talk(`Sounds good to me.`);

        return jump(ClubHome, "ClubHome");



    }
    mc.think(`Time to head back.`);
    ImageClass.setImage(images.v4.Car1, { transition: true });
    mc.think(`The streets are so empty.`);
    mc.think(`I didn't realize we got so far from the bar.`);
    return jump(ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar, "ClubEventJoeInsideAnnAloneStatus1Or5ChrisCar");

};

